import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { Spin, App as AntApp } from 'antd';
import axios from 'axios';
import Setup from './pages/Setup';
import Login from './pages/Login';
import InitSetup from './pages/InitSetup';
import Dashboard from './pages/Dashboard';
import BotsManagement from './pages/BotsManagement';
import BotMessages from './pages/BotMessages';
import GroupManagement from './pages/GroupManagement';
import AdminsManagement from './pages/AdminsManagement';
import AutoRepliesManagement from './pages/AutoRepliesManagement';
import CommandTemplates from './pages/CommandTemplates';
import CommandSettings from './pages/CommandSettings';
import TwoFactorAuth from './pages/TwoFactorAuth';
import BroadcastTasks from './pages/BroadcastTasks';
import SensitiveWordRules from './pages/SensitiveWordRules';
import MediaManagement from './pages/MediaManagement';
import ChannelManagement from './pages/ChannelManagement';
import NotificationTemplates from './pages/NotificationTemplates';
import './App.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

// 根路由重定向组件
const RootRedirect: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [needsSetup, setNeedsSetup] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    checkSetupStatus();
  }, []);

  const checkSetupStatus = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/setup/check`);
      const { needsSetup } = response.data;

      setNeedsSetup(needsSetup);
      setLoading(false);

      if (needsSetup) {
        navigate('/setup');
      } else {
        navigate('/dashboard');
      }
    } catch (error) {
      console.error('检查初始化状态失败:', error);
      setLoading(false);
      // 出错时默认跳转到登录页
      navigate('/login');
    }
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh'
      }}>
        <Spin size="large" tip="正在检查系统状态..." />
      </div>
    );
  }

  return null;
};

const App: React.FC = () => {
  return (
    <AntApp>
      <BrowserRouter>
        <Routes>
          <Route path="/setup" element={<Setup />} />
          <Route path="/init-setup" element={<InitSetup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />}>
            <Route index element={<Navigate to="/dashboard/bots" replace />} />
            <Route path="bots" element={<BotsManagement />} />
            <Route path="groups" element={<GroupManagement />} />
            <Route path="channels" element={<ChannelManagement />} />
            <Route path="auto-replies" element={<AutoRepliesManagement />} />
            <Route path="command-templates" element={<CommandTemplates />} />
            <Route path="command-settings" element={<CommandSettings />} />
            <Route path="sensitive-words" element={<SensitiveWordRules />} />
            <Route path="broadcast" element={<BroadcastTasks />} />
            <Route path="notifications" element={<NotificationTemplates />} />
            <Route path="media" element={<MediaManagement />} />
            <Route path="admins" element={<AdminsManagement />} />
            <Route path="2fa" element={<TwoFactorAuth />} />
          </Route>
          <Route path="/bot-messages/:id" element={<BotMessages />} />
          <Route path="/" element={<RootRedirect />} />
        </Routes>
      </BrowserRouter>
    </AntApp>
  );
};

export default App;
